module.exports = __webpack_public_path__ + "img/bishop-hero-2.67694d7a.jpg";